import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import styles from "./Pricing.module.css";
import PricingOption from "../../components/PricingOption/PricingOption";
import ProfileForm from "../../components/ProfileForm";
import SignupErrorMessage from "../../components/SignupErrorMessage/SignupErrorMessage";
//import PaymentBox from "../../components/PaymentBox";
import ConfirmationMessage from "../../components/ConfirmationMessage/ConfirmationMessage"; // Import the renamed component
import GlacierPayment from "../../components/GlacierPayment/GlacierPayment";
import SubscriptionSuccess from "../../components/SubscriptionSuccess/SubscriptionSuccess";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";
import AttentionModal from "../../components/Pricing/AttentionModal/AttentionModal";
import { StaticRoutes } from "../routes";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { AccountContainer } from "../../hooks/useAccount";
import environment from "../../environment";
import Loader from "../../components/Loader/Loader";
import classNames from "classnames";

const Pricing = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  pricingOptions = [
    {
      packageName: "BidPro Bundle",
      priceMonthly: "26.99",
      priceAnnual: "323.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Access to all the BidPro apps including:",
            features: [
              {
                feature: "Web-based Bidding",
                isNew: "",
              },
              {
                feature: "Seniority",
                isNew: "",
              },
              {
                feature: "Web-based TripBoard",
                isNew: "",
              },
              {
                feature: "iOS Mobile TripBoard",
                isNew: "NEW!*",
              },
            ],
          },
        },
      ],
      isBundle: true,
      savings: "10%",
      note: "Unlimited downloads for all your iOS devices included!",
    },
    {
      packageName: "Bidding & Seniority",
      priceMonthly: "9.99",
      priceAnnual: "119.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "Bidding",
            features: [
              {
                feature: "Download bid packages",
                isNew: "",
              },
              {
                feature: "Customize bidline colors & sorts",
                isNew: "",
              },
              {
                feature: "Search & prepare bids offline",
                isNew: "",
              },
              {
                feature: "Submit bids directly and skip PBSI",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "Seniority",
            features: [
              {
                feature: "View Seniority Ranking on a detailed graph",
                isNew: "",
              },
              {
                feature: "Compare rankings to other fleets",
                isNew: "",
              },
              {
                feature: "View yearly retires and estimate seniority",
                isNew: "",
              },
              {
                feature: "Use offline",
                isNew: "",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
    {
      packageName: "TripBoard",
      priceMonthly: "19.99",
      priceAnnual: "239.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Web-based TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "View estimated pay & credit",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "",
            header: "IOS Mobile TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "Sync your schedule to your device",
                isNew: "NEW!",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const [formData, setFormData] = useState(null);
  const [paymentResponse, setPaymentResponse] = useState(null);
  const [animate, setAnimate] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentStep, setCurrentStep] = useState("pricing"); // Tracks current step: 'pricing', 'profile', 'confirmation', 'payment', 'success'
  const [showErrorComponent, setShowErrorComponent] = useState(false);
  const [zip, setZip] = useState("");
  const { validateUser } = AccountContainer.useContainer();
  const [profileData, setProfileData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [didPayUpdateFail, setDidPayUpdateFail] = useState(false);
  const [userValid, setUserValid] = useState(false);
  const [closeButtonClicked, setCloseButtonClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isActiveLabel, setIsActiveLabel] = useState("");
  const [userData, setUserData] = useState(null);
  const [accountUpdateProfileError, setAccountUpdateProfileError] =
    useState("");

  useEffect(() => {
    if (currentStep === "profile") {
      const body = document.body;
      body.scrollTo({ top: 0, behavior: "smooth" });
    }
    if (!profileData && currentStep === "profile") {
      const fetchProfileData = async () => {
        try {
          const response = await fetch(
            environment.apiBase + "/UserGetFormData",
            {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!response.ok) {
            throw new Error(
              `Error: ${response.status} - ${response.statusText}`
            );
          }

          const data = await response.json();
          setProfileData(data);
        } catch (error) {
          setShowErrorComponent(true); // Show error component
        }
      };

      fetchProfileData();
    }
  }, [currentStep]);

  const checkUser = async () => {
    try {
      const result = await validateUser();

      if (!result) {
        // Not logged in, show login modal
        setUserValid(false);
        setIsModalOpen(true);
        return false;
      }

      setUserValid(true);
      setIsModalOpen(false);

      const subscription = result.activeSubscriptions?.find(
        (sub) => sub.ActiveSubscription
      );

      if (result.active && subscription) {
        const subscription = result.activeSubscriptions?.[0];

        let productName = subscription.ProductName;
        let price = subscription.BillingPrice;
        let cycle = subscription.BillingCycle;

        if (cycle == 1) {
          cycle = "monthly";
        } else {
          cycle = "annually";
        }

        if (productName == "Bidding") {
          productName = "Bidding & Seniority";
        }
        if (productName == "Bundle") {
          productName = "BidPro Bundle";
        }
        setSelectedProduct({
          productName,
          price,
          cycle,
        });
        navigate("/account");
        return false;
        //setCurrentStep("success");
      }
      return true;
    } catch (error) {
      setUserValid(false);
      setIsModalOpen(true);
      return false;
      // setIsModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLoginClose = () => {
    if (!userValid) {
      setCurrentStep("pricing");
    }
  };

  const handleModalCloseClick = () => {
    setCloseButtonClicked(true);
    setIsModalOpen(false);
    handleLoginClose();
  };

  //NEW - ALL COMMENTED OUT BELOW
  // const handleLabelClick = (label) => {

  //   setIsActiveLabel("SIGN UP");

  //   if (label.startsWith("SIGN UP")) {
  //     setIsModalOpen(true);
  //   }
  // };

  // const handleNavigation = (item, isOption = false, parentLabel = "") => {
  //   if (isOption && parentLabel.toUpperCase() === "SIGN UP") {
  //     setIsActiveLabel((prev) => {
  //       return "SIGN UP";
  //     });

  //     return;
  //   }

  //   if (item.path) {
  //     setIsActiveLabel("");
  //     setIsModalOpen(false);
  //     navigate(item.path);
  //   }
  // };

  // useEffect(() => {
  //   if (isActiveLabel === "SIGN UP") {
  //     setIsModalOpen(true);
  //   }
  // }, [isActiveLabel]);

  // useEffect(() => {
  //   setAnimate(true);
  //   // setIsModalOpen(true);
  // }, []);

  // useEffect(() => {
  //   if (!profileData) {
  //     setIsModalOpen(true);
  //   } else {
  //     setIsModalOpen(false);
  //   }
  // }, [profileData]);

  const navigate = useNavigate();

  //NEW

  // const navListWithNavigate = navList.map((item) => ({
  //   ...item,
  //   onClick: item.options?.length ? undefined : () => navigate(item.path),

  //   options: item.options?.map((option) => ({
  //     ...option,
  //     onClick: () => {
  //       handleNavigation(option, true, item.label);
  //     },
  //   })),
  // }));

  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  useEffect(() => {
    setAnimate(true);
    setIsModalOpen(false); //is model open on render?
  }, []);

  const handleProfileSave = async (data) => {
    setIsLoading(true);
    setAccountUpdateProfileError("");
    //this is where you would verify if the email is actually unique or not for the registration process.
    try {
      const fetchResponse = await fetch(
        environment.apiBase + "/account/updateprofile",
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (fetchResponse.ok) {
        //currently, the update endpoint enforces the need for some profile data. even though we are already updating the stuff on this step, set it in state and we will pass it with the account/udpdate request
        setFormData(data); // Save form data in state
        setCurrentStep("confirmation"); // Move to confirmation step
        setIsLoading(false);
      } else {
        let body = await fetchResponse.json();

        setAccountUpdateProfileError(body.message);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const attemptAccountUpdate = async (combinedData) => {
    try {
      const fetchResponse = await fetch(
        environment.apiBase + "/account/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(combinedData),
          credentials: "include",
        }
      );

      const result = await fetchResponse.json();

      if (fetchResponse.ok) {
        return { success: true, result };
      } else {
        return { success: false, error: result };
      }
    } catch (error) {
      return { success: false, error };
    }
  };

  const handlePaymentSuccess = async (response) => {
    setIsLoading(true);
    try {
      setPaymentResponse(response.token);
      setZip(response.zip);
      setErrorMessage(null);

      const combinedData = {
        ...formData,
        paymentToken: response.token,
        cardFirstName: response.cardFirstName,
        cardLastName: response.cardLastName,
        zipcode: response.zip,
        productPrice: selectedProduct?.price,
        productCycle: selectedProduct?.cycle,
      };

      const { success, error } = await attemptAccountUpdate(combinedData);
      if (success) {
        setCurrentStep("success");
        return;
      } else if (
        error?.message === "Failed to create customer." // Check for specific message
      ) {
        setErrorMessage("Failed to create customer. Please contact support!");
        setDidPayUpdateFail(true);
        return;
      } else {
        // setErrorMessage(
        //   `Update failed after ${maxRetries} attempts. Please contact support!`
        // );
        setDidPayUpdateFail(true);
        setErrorMessage(error?.message);
      }

      //setCurrentStep("success");
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmation = async (productName, cycle) => {
    setIsLoading(true);
    //if logged in already, skip
    //if not, prompt login modal here.
    //if closed without signing in just go back to pricing page. (dont go to sign up error screen)
    const userIsValid = await checkUser();

    if (!userIsValid) {
      // We'll open the modal in checkUser() (already done).
      // If user cancels the modal, we return to pricing in handleModalCloseClick
      return;
    }

    const selectedOption = pricingOptions.find(
      (option) => option.packageName === productName
    );

    if (!selectedOption) {
      return;
    }

    //const logo = selectedOption.sections[0]?.section.logo || ""; // Default to the first logo
    const logos = selectedOption.sections
      .map((s) => s.section.logo)
      .filter(Boolean);

    const price =
      cycle === "monthly"
        ? selectedOption.priceMonthly
        : selectedOption.priceAnnual;

    const features = selectedOption.sections.flatMap((s) =>
      s.section.features.map((f) => f.feature)
    );
    setSelectedProduct({
      productName,
      imageSrc: logos,
      price,
      features,
      cycle,
    });
    setCurrentStep("profile"); // Move to profile form step SHOULD BE PROFILE
    setIsLoading(false);
  };

  //NEW
  const handleOnCancelSignUP = () => {
    setShowErrorComponent(true);

    setTimeout(() => {
      setShowErrorComponent(false);
      setIsModalOpen(false);
      window.location.reload();

      setCurrentStep("pricing");
    }, 2000);
  };

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      <div className={styles.pageContainer}>
        {showErrorComponent ? (
          <SignupErrorMessage
            onBackToLogin={() => navigate("/login")}
            position="LOGIN"
            airline="UPS"
          />
        ) : (
          <>
            {isLoading && (
              <>
                <div className={styles.loaderContainer}>
                  <Loader color={"#3c4554"} size={75} />
                </div>
              </>
            )}

            {currentStep === "pricing" && !isLoading && (
              <>
                <div className={styles.header}>
                  <h2 className={styles.subHeader}>Pricing</h2>
                  <p>
                    BidPro software products are offered as monthly or annual
                    subscriptions. To view a more detailed product description,
                    select Bidding, TripBoard, or Seniority from the PRODUCTS
                    dropdown.
                  </p>
                </div>
                <div
                  className={`row ${animate ? styles.slideIn : ""}`}
                  id={styles.options}
                >
                  {pricingOptions.map((option, index) => (
                    <div className={styles.col} key={index}>
                      <PricingOption
                        {...option}
                        onMonthly={() =>
                          handleConfirmation(option.packageName, "monthly")
                        }
                        onAnnual={() =>
                          handleConfirmation(option.packageName, "annual")
                        }
                      />
                    </div>
                  ))}
                </div>
              </>
            )}

            {currentStep === "profile" && !isLoading && (
              <div className={styles.profileFormContainer}>
                <div className="row justify-content-center mb-3">
                  <div className="col-12">
                    <h5 className="text-center">Let's get started...</h5>
                  </div>
                </div>
                <div className={styles.headerContainer}>
                  <div className="col-12">
                    <p className={styles.profileHeader}>
                      Your name, airline, and GEMs have been provided by UPS. If
                      you find an issue with the <br /> information displayed
                      here, please reach out to Tech Support to resolve.
                    </p>
                  </div>
                  <div className="col-12">
                    <p className={styles.profileHeader}>
                      The password that you create here will be used to access
                      all of the web pages and apps <br /> included in your
                      subscription.
                    </p>
                  </div>
                </div>
                <div>
                  {accountUpdateProfileError && (
                    <div className={styles.customAlert} role="alert">
                      {accountUpdateProfileError}
                    </div>
                  )}
                </div>
                <ProfileForm
                  profileEditable={true}
                  initialFirstName={profileData?.FirstName}
                  initialLastName={profileData?.LastName}
                  initialPosition={profileData?.PositionName}
                  initialEquipment={profileData?.EquipmentName}
                  initialBase={profileData?.BaseName}
                  initialEmployeeNumber={profileData?.UserName}
                  initialEmail={profileData?.Email}
                  initialPhoneNumber={profileData?.PhoneNumber}
                  initialPassword=""
                  initialConfirmPassword=""
                  // onCancel={() => setCurrentStep("pricing")} // Return to pricing if canceled
                  onCancel={handleOnCancelSignUP}
                  onSave={handleProfileSave} // Handle successful save
                  onError={() => setShowErrorComponent(true)} // Show error component on error
                  isPasswordReset={profileData?.IsResettingPassword}
                />
              </div>
            )}

            {currentStep === "confirmation" && !isLoading && (
              <ConfirmationMessage
                product={selectedProduct?.productName}
                imageSrc={selectedProduct?.imageSrc}
                price={selectedProduct?.price}
                features={selectedProduct?.features}
                cycle={selectedProduct?.cycle}
                onContinue={() => setCurrentStep("payment")}
                onCancel={() => setCurrentStep("profile")} // Return to profile if canceled
              />
            )}

            {currentStep === "payment" && !isLoading && (
              <div className={styles.paymentContainer}>
                <div className="row justify-content-center mt-3">
                  <div className="col-12">
                    <h5 className="text-center">Enter payment info...</h5>
                  </div>
                </div>
                <div className="row justify-content-center mt-3">
                  <div className="col-12">
                    <p className={styles.signup}>
                      Enter your payment information below and click{" "}
                      <b>Submit</b> to
                      <br />
                      complete your signup.
                    </p>
                  </div>
                </div>
                {errorMessage && (
                  <div
                    className={classNames(
                      styles.customAlert,
                      styles.shortAlertBox
                    )}
                    role="alert"
                  >
                    {errorMessage}
                  </div>
                )}
                <GlacierPayment
                  product={selectedProduct?.productName}
                  price={selectedProduct?.price}
                  cycle={selectedProduct?.cycle}
                  onCancel={() => setCurrentStep("confirmation")} // Return to confirmation if canceled
                  onSuccess={(response) => {
                    handlePaymentSuccess(response);
                  }} // Handle successful payment
                  didFail={didPayUpdateFail}
                  errorMessage={didPayUpdateFail}
                />
              </div>
            )}

            {currentStep === "success" && !isLoading && (
              <SubscriptionSuccess
                product={selectedProduct?.productName}
                price={selectedProduct?.price}
                cycle={selectedProduct?.cycle}
                imageSrc={selectedProduct?.imageSrc}
                formData={formData}
                paymentResponse={paymentResponse}
                zip={zip}
                onContinue={() => navigate("/dashboard")}
              />
            )}
          </>
        )}
      </div>
      <Footer lists={footerLists} inverse={true} />

      {/* NEW */}
      {/* {!isLoading &&
        isActiveLabel.startsWith("SIGN UP") &&
        profileData !== undefined &&
        profileData !== null &&
        !profileData?.UserName &&
        isModalOpen && (
          <>
            <AttentionModal
              isOpen={isModalOpen}
              // onCloseButtonClick={() => setIsModalOpen(false)}
              onCloseButtonClick={() => {
                setIsModalOpen(false);
                setIsActiveLabel("");
              }}
              // onCloseButtonClick={handleModalCloseClick}
              airline="UPS"
            />
          </>
        )} */}

      {!isLoading && isModalOpen && (
        <AttentionModal
          isOpen={isModalOpen}
          // onCloseButtonClick={() => setIsModalOpen(false)}
          onCloseButtonClick={handleModalCloseClick}
          airline="UPS"
        />
      )}
    </>
  );
};

Pricing.propTypes = {
  navList: PropTypes.array,
  pricingOptions: PropTypes.array,
  footerLists: PropTypes.array,
};

export default Pricing;

// import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
// import { useNavigate } from "react-router-dom";
// import styles from "./Pricing.module.css";
// import PricingOption from "../../components/PricingOption/PricingOption";
// import ProfileForm from "../../components/ProfileForm";
// import SignupErrorMessage from "../../components/SignupErrorMessage/SignupErrorMessage";
// //import PaymentBox from "../../components/PaymentBox";
// import ConfirmationMessage from "../../components/ConfirmationMessage/ConfirmationMessage"; // Import the renamed component
// import GlacierPayment from "../../components/GlacierPayment/GlacierPayment";
// import SubscriptionSuccess from "../../components/SubscriptionSuccess/SubscriptionSuccess";
// import Nav from "../../components/Nav/Nav";
// import Footer from "../../components/Footer/Footer";
// import AttentionModal from "../../components/Pricing/AttentionModal/AttentionModal";
// import { StaticRoutes } from "../routes";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import { AccountContainer } from "../../hooks/useAccount";
// import environment from "../../environment";

// const Pricing = ({
//   navList = [
//     {
//       label: "HOME",
//       options: [],
//       border: false,
//       path: StaticRoutes.Home,
//     },
//     {
//       label: "PRODUCTS",
//       options: [
//         { label: "BIDDING", path: StaticRoutes.Bidding },
//         { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
//         { label: "SENIORITY", path: StaticRoutes.Seniority },
//       ],
//       border: false,
//     },
//     {
//       label: "PRICING",
//       options: [
//         { label: "UPS", path: StaticRoutes.UPSPricing },
//         { label: "AMERICAN", path: StaticRoutes.Bidding },
//         { label: "ALASKA", path: StaticRoutes.TripBoard },
//         { label: "JETSUITE", path: StaticRoutes.Bidding },
//       ],
//       border: false,
//     },
//     {
//       label: "CONTACT US",
//       options: [],
//       border: false,
//       path: StaticRoutes.Contact,
//     },
//     /*{
//       label: "LOG IN",
//       options: [],
//       border: false,
//       path: StaticRoutes.Login,
//     },*/
//     {
//       label: "SIGN UP",
//       options: [
//         { label: "UPS", path: StaticRoutes.UPSPricing },
//         { label: "AMERICAN", path: StaticRoutes.Bidding },
//         { label: "ALASKA", path: StaticRoutes.TripBoard },
//         { label: "JETSUITE", path: StaticRoutes.Bidding },
//       ],
//       border: true,
//     },
//   ],
//   pricingOptions = [
//     {
//       packageName: "BidPro Bundle",
//       priceMonthly: "26.99",
//       priceAnnual: "323.88",
//       onMonthly: null,
//       onAnnual: null,
//       sections: [
//         {
//           section: {
//             logo: "BidProPlusBiddingLogo.png",
//             header: "",
//             features: [],
//           },
//         },
//         {
//           section: {
//             logo: "BidProPlusSeniorityLogo.png",
//             header: "",
//             features: [],
//           },
//         },
//         {
//           section: {
//             logo: "BidProPlusTripBoardLogo.png",
//             header: "Access to all the BidPro apps including:",
//             features: [
//               {
//                 feature: "Web-based Bidding",
//                 isNew: "",
//               },
//               {
//                 feature: "Seniority",
//                 isNew: "",
//               },
//               {
//                 feature: "Web-based TripBoard",
//                 isNew: "",
//               },
//               {
//                 feature: "iOS Mobile TripBoard",
//                 isNew: "NEW!*",
//               },
//             ],
//           },
//         },
//       ],
//       isBundle: true,
//       savings: "10%",
//       note: "Unlimited downloads for all your iOS devices included!",
//     },
//     {
//       packageName: "Bidding & Seniority",
//       priceMonthly: "9.99",
//       priceAnnual: "119.88",
//       onMonthly: null,
//       onAnnual: null,
//       sections: [
//         {
//           section: {
//             logo: "BidProPlusBiddingLogo.png",
//             header: "Bidding",
//             features: [
//               {
//                 feature: "Download bid packages",
//                 isNew: "",
//               },
//               {
//                 feature: "Customize bidline colors & sorts",
//                 isNew: "",
//               },
//               {
//                 feature: "Search & prepare bids offline",
//                 isNew: "",
//               },
//               {
//                 feature: "Submit bids directly and skip PBSI",
//                 isNew: "",
//               },
//             ],
//           },
//         },
//         {
//           section: {
//             logo: "BidProPlusSeniorityLogo.png",
//             header: "Seniority",
//             features: [
//               {
//                 feature: "View Seniority Ranking on a detailed graph",
//                 isNew: "",
//               },
//               {
//                 feature: "Compare rankings to other fleets",
//                 isNew: "",
//               },
//               {
//                 feature: "View yearly retires and estimate seniority",
//                 isNew: "",
//               },
//               {
//                 feature: "Use offline",
//                 isNew: "",
//               },
//             ],
//           },
//         },
//       ],
//       isBundle: false,
//       savings: "",
//       note: "",
//     },
//     {
//       packageName: "TripBoard",
//       priceMonthly: "19.99",
//       priceAnnual: "239.88",
//       onMonthly: null,
//       onAnnual: null,
//       sections: [
//         {
//           section: {
//             logo: "BidProPlusTripBoardLogo.png",
//             header: "Web-based TripBoard",
//             features: [
//               {
//                 feature: "View Schedule",
//                 isNew: "",
//               },
//               {
//                 feature: "Post & pick up trips",
//                 isNew: "",
//               },
//               {
//                 feature: "Receive trip notifications via text or email",
//                 isNew: "",
//               },
//               {
//                 feature: "View estimated pay & credit",
//                 isNew: "",
//               },
//             ],
//           },
//         },
//         {
//           section: {
//             logo: "",
//             header: "IOS Mobile TripBoard",
//             features: [
//               {
//                 feature: "View Schedule",
//                 isNew: "",
//               },
//               {
//                 feature: "Post & pick up trips",
//                 isNew: "",
//               },
//               {
//                 feature: "Receive trip notifications via text or email",
//                 isNew: "",
//               },
//               {
//                 feature: "Sync your schedule to your device calandars",
//                 isNew: "NEW!",
//               },
//             ],
//           },
//         },
//       ],
//       isBundle: false,
//       savings: "",
//       note: "",
//     },
//   ],
//   footerLists = [
//     {
//       header: "MENU",
//       links: [
//         { name: "Home", src: StaticRoutes.Home },
//         { name: "Contact Us", src: StaticRoutes.Contact },
//         { name: "Sign Up", src: StaticRoutes.Home },
//       ],
//     },
//     {
//       header: "PRODUCTS",
//       links: [
//         { name: "Bidding", src: StaticRoutes.Bidding },
//         { name: "Trip Board", src: StaticRoutes.TripBoard },
//         { name: "Seniority", src: StaticRoutes.Seniority },
//         { name: "Pricing", src: StaticRoutes.UPSPricing },
//       ],
//     },
//     {
//       header: "TECH SUPPORT",
//       links: [
//         { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
//         { name: "1-800-918-4980", src: "tel:18009184980" },
//       ],
//     },
//   ],
// }) => {
//   const [formData, setFormData] = useState(null);
//   const [paymentResponse, setPaymentResponse] = useState(null);
//   const [animate, setAnimate] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(true);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [currentStep, setCurrentStep] = useState("pricing"); // Tracks current step: 'pricing', 'profile', 'confirmation', 'payment', 'success'
//   const [showErrorComponent, setShowErrorComponent] = useState(false);
//   const [zip, setZip] = useState("");
//   const { validateUser } = AccountContainer.useContainer();
//   const [profileData, setProfileData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [userValid, setUserValid] = useState(false);
//   const [closeButtonClicked, setCloseButtonClicked] = useState(false);
//   const [errorMessage, setErrorMessage] = useState(null);

//   useEffect(() => {
//     if (currentStep === "profile") {
//       const fetchProfileData = async () => {
//         try {
//           const response = await fetch(
//             environment.apiBase + "/UserGetFormData",
//             {
//               method: "GET",
//               credentials: "include",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//             }
//           );

//           if (!response.ok) {
//             throw new Error(
//               `Error: ${response.status} - ${response.statusText}`
//             );
//           }

//           const data = await response.json();
//           setProfileData(data);
//         } catch (error) {
//           setShowErrorComponent(true); // Show error component
//         }
//       };

//       fetchProfileData();
//     }
//   }, [currentStep]);

//   useEffect(() => {
//     const checkUser = async () => {
//       try {
//         const result = await validateUser();
//         setUserValid(true);
//         setIsModalOpen(false);

//         if (result.active) {
//           const subscription = result.activeSubscriptions?.[0];

//           let productName = subscription.ProductName;
//           let price = subscription.BillingPrice;
//           let cycle = subscription.BillingCycle;

//           if (cycle == 1) {
//             cycle = "monthly";
//           } else {
//             cycle = "annually";
//           }

//           if (productName == "Bidding") {
//             productName = "Bidding & Seniority";
//           }
//           if (productName == "Bundle") {
//             productName = "BidPro Bundle";
//           }
//           setSelectedProduct({
//             productName,
//             price,
//             cycle,
//           });

//           setCurrentStep("success");
//         }
//       } catch (error) {
//         setIsModalOpen(true);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     checkUser();
//   }, []);

//   const handleLoginClose = () => {
//     if (!userValid) {
//       setShowErrorComponent(true);
//     }
//   };

//   const handleModalCloseClick = () => {
//     setCloseButtonClicked(true);
//     setIsModalOpen(false);
//     handleLoginClose();
//   };

//   const navigate = useNavigate();
//   const navListWithNavigate = navList.map((item) => ({
//     ...item,
//     onClick: () => navigate(item.path),
//     options: item.options?.map((option) => ({
//       ...option,
//       onClick: () => navigate(option.path),
//     })),
//   }));

//   useEffect(() => {
//     setAnimate(true);
//     setIsModalOpen(true);
//   }, []);

//   const handleProfileSave = (data) => {
//     setFormData(data); // Save form data in state
//     setCurrentStep("confirmation"); // Move to confirmation step
//   };

//   const attemptAccountUpdate = async (combinedData, attempt = 1) => {
//     try {
//       const fetchResponse = await fetch(
//         environment.apiBase + "/account/update",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(combinedData),
//           credentials: "include",
//         }
//       );

//       const result = await fetchResponse.json();

//       if (fetchResponse.ok) {
//         return { success: true, result };
//       } else {

//         return { success: false, error: result };
//       }
//     } catch (error) {
//       return { success: false, error };
//     }
//   };
//   const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//   const maxRetries = 3;
//   const handlePaymentSuccess = async (response) => {
//     try {
//       setPaymentResponse(response.token);
//       setZip(response.zip);
//       setErrorMessage(null);

//       const combinedData = {
//         ...formData,
//         paymentToken: response.token,
//         zipcode: response.zip,
//         productPrice: selectedProduct?.price,
//         productCycle: selectedProduct?.cycle,
//       };

//       for (let attempt = 1; attempt <= maxRetries; attempt++) {
//         const { success } = await attemptAccountUpdate(combinedData, attempt);
//         if (success) {
//           setCurrentStep("success");
//           return;
//         } else if (attempt < maxRetries) {
//           await sleep(2000);
//         } else {
//           setErrorMessage(
//             `Update failed after ${maxRetries} attempts. Please contact support!`
//           );
//         }
//       }

//       //setCurrentStep("success");
//     } catch (error) {
//     }
//   };

//   const handleConfirmation = (productName, cycle) => {
//     const selectedOption = pricingOptions.find(
//       (option) => option.packageName === productName
//     );

//     if (!selectedOption) {
//       return;
//     }

//     //const logo = selectedOption.sections[0]?.section.logo || ""; // Default to the first logo
//     const logos = selectedOption.sections
//       .map((s) => s.section.logo)
//       .filter(Boolean);

//     const price =
//       cycle === "monthly"
//         ? selectedOption.priceMonthly
//         : selectedOption.priceAnnual;

//     const features = selectedOption.sections.flatMap((s) =>
//       s.section.features.map((f) => f.feature)
//     );
//     setSelectedProduct({
//       productName,
//       imageSrc: logos,
//       price,
//       features,
//       cycle,
//     });
//     setCurrentStep("profile"); // Move to profile form step SHOULD BE PROFILE
//   };

//   return (
//     <>
//       <Nav
//         isStatic={true}
//         navItems={navListWithNavigate}
//         onClickLogo={() => navigate("/")}
//       />
//       <div className={styles.pageContainer}>
//         {showErrorComponent ? (
//           <SignupErrorMessage
//             onBackToLogin={() => navigate("/login")}
//             position="LOGIN"
//             airline="UPS"
//           />
//         ) : (
//           <>
//             {currentStep === "pricing" && (
//               <>
//                 <div className={styles.header}>
//                   <h5>Pricing</h5>
//                   <p>
//                     BidPro software products are offered as monthly or annual
//                     subscriptions. To view a more detailed product description,
//                     select Bidding, TripBoard, or Seniority from the PRODUCTS
//                     dropdown.
//                   </p>
//                 </div>
//                 <div
//                   className={`row ${animate ? styles.slideIn : ""}`}
//                   id={styles.options}
//                 >
//                   {pricingOptions.map((option, index) => (
//                     <div className={styles.col} key={index}>
//                       <PricingOption
//                         {...option}
//                         onMonthly={() =>
//                           handleConfirmation(option.packageName, "monthly")
//                         }
//                         onAnnual={() =>
//                           handleConfirmation(option.packageName, "annual")
//                         }
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}

//             {currentStep === "profile" && (
//               <div className={styles.profileFormContainer}>
//                 <h5>
//                   Complete Your Sign Up for {selectedProduct?.productName}
//                 </h5>
//                 {}
//                 <ProfileForm
//                   initialFirstName={profileData?.FirstName}
//                   initialLastName={profileData?.LastName}
//                   initialPosition={profileData?.PositionName}
//                   initialEquipment={profileData?.EquipmentName}
//                   initialBase={profileData?.BaseName}
//                   initialEmployeeNumber={profileData?.UserName}
//                   initialEmail={profileData?.Email}
//                   initialPassword=""
//                   initialConfirmPassword=""
//                   onCancel={() => setCurrentStep("pricing")} // Return to pricing if canceled
//                   onSave={handleProfileSave} // Handle successful save
//                   onError={() => setShowErrorComponent(true)} // Show error component on error
//                 />
//               </div>
//             )}

//             {currentStep === "confirmation" && (
//               <ConfirmationMessage
//                 product={selectedProduct?.productName}
//                 imageSrc={selectedProduct?.imageSrc}
//                 price={selectedProduct?.price}
//                 features={selectedProduct?.features}
//                 cycle={selectedProduct?.cycle}
//                 onContinue={() => setCurrentStep("payment")}
//                 onCancel={() => setCurrentStep("profile")} // Return to profile if canceled
//               />
//             )}

//             {currentStep === "payment" && (
//               <div className={styles.paymentContainer}>
//                 <h5>
//                   Complete Your Payment for {selectedProduct?.productName}
//                 </h5>
//                 {errorMessage && (
//                   <div className={styles.customAlert} role="alert">
//                     {errorMessage}
//                   </div>
//                 )}
//                 <GlacierPayment
//                   product={selectedProduct?.productName}
//                   price={selectedProduct?.price}
//                   cycle={selectedProduct?.cycle}
//                   onCancel={() => setCurrentStep("confirmation")} // Return to confirmation if canceled
//                   onSuccess={(response) => {
//                     handlePaymentSuccess(response);
//                   }} // Handle successful payment
//                 />
//               </div>
//             )}

//             {currentStep === "success" && (
//               <SubscriptionSuccess
//                 product={selectedProduct?.productName}
//                 price={selectedProduct?.price}
//                 cycle={selectedProduct?.cycle}
//                 imageSrc={selectedProduct?.imageSrc}
//                 formData={formData}
//                 paymentResponse={paymentResponse}
//                 zip={zip}
//                 onContinue={() => navigate("/dashboard")}
//               />
//             )}
//           </>
//         )}
//       </div>
//       <Footer lists={footerLists} inverse={true} />
//       <AttentionModal
//         isOpen={!isLoading && isModalOpen}
//         //onCloseButtonClick={() => setIsModalOpen(false)}
//         onCloseButtonClick={handleModalCloseClick}
//         airline="UPS"
//       />
//     </>
//   );
// };

// Pricing.propTypes = {
//   navList: PropTypes.array.isRequired,
//   pricingOptions: PropTypes.array.isRequired,
//   footerLists: PropTypes.array.isRequired,
// };

// export default Pricing;
